import React from "react";
import { Link } from "react-router-dom";
import { DemoChip, StatusPill } from "@/components/Chips";

/**
 * Mobile-only card renderer for list screens. Kept dumb on purpose so each
 * list page can compose primary/secondary/status/right slots without any
 * shared state or complex prop-passing.
 *
 * Wrap it in a `md:hidden` container in the caller.
 */
export const MobileListCard = ({
  to,
  primary,
  secondary,
  status,
  right,
  isDemo,
  monoTag,
  testid,
}) => {
  const Card = (
    <div
      data-testid={testid}
      className="bg-white border border-coach-silver rounded-md shadow-sm p-4 flex items-start gap-3"
    >
      <div className="flex-1 min-w-0">
        {monoTag && (
          <div className="text-[10.5px] font-mono uppercase tracking-widest text-steel mb-1">
            {monoTag}
          </div>
        )}
        <div className="flex items-center gap-2 flex-wrap">
          <div className="text-[15px] font-semibold text-carbon leading-tight break-words">
            {primary}
          </div>
          {isDemo && <DemoChip />}
        </div>
        {secondary && (
          <div className="text-[13px] text-steel mt-1 leading-snug">{secondary}</div>
        )}
      </div>
      <div className="shrink-0 flex flex-col items-end gap-1.5">
        {status && <StatusPill status={status} />}
        {right}
      </div>
    </div>
  );
  if (to) {
    return (
      <Link to={to} className="block hover:no-underline">
        {Card}
      </Link>
    );
  }
  return Card;
};

/**
 * Wrapper that renders the desktop table (children #1) OR mobile cards
 * (children #2) depending on breakpoint. Callers pass both.
 */
export const ListLayout = ({ desktop, mobile }) => (
  <>
    <div className="hidden md:block">{desktop}</div>
    <div className="md:hidden space-y-3">{mobile}</div>
  </>
);
